import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {RootState} from '../../store';
import UserMgmtCrud from '../../screens/settings/users/api';
import UserPermission from './UserPermission';
import {UserAccess} from '../../screens/settings/users/types';

interface FolderInformation {
    folderInfo: any;
}

export default function FolderShare({folderInfo}: FolderInformation) {
    const userProfileProps = useSelector((state: RootState) => state.userProfile);
    const [users, setUsers] = useState<UserAccess[] | undefined>([]);

    const org_uid = userProfileProps.currentOrganization.uid;

    useEffect(() => {
        if (org_uid) {
            UserMgmtCrud.list(org_uid).then((result) => {
                if (!!result.error) {
                    alert(result.error);
                } else {
                    setUsers(result.data);
                }
            });
        }
    }, [org_uid]);

    return (
        <>
            <span className='text-[20px] font-[600] text-[#7D7D77]'>People with access</span>
            {users &&
                users
                    .filter((user) => user.role !== 'Owner')
                    .map((user) => (
                        <UserPermission
                            key={user.email}
                            user={user}
                            initialPermission={'READ'}
                            folderInfo={folderInfo}
                            org_uid={org_uid}
                        />
                    ))}
        </>
    );
}
